<template>
  <div class="page-content-form">

    <div v-if="content !== false && !selecting" class="page-content">
      <div class="content-item">
        <strong><em>{{ content.page_content_type }}</em></strong>
        -
        <router-link v-if="linked.name"
                     :to="{ name: content.page_content_type.toLowerCase(), params: {id: content.page_content_id}}">
          {{ linked.sku ? '#' + linked.sku + ' - ' : '' }} {{ linked.name }}
        </router-link>
        <br />
        <br />
        <div v-if="linked.images && linked.images.length > 0" class="columns margin-top">
          <div class="column is-3">
            <img :src="linked.images[0].thumbnail_path">
          </div>
          <div class="column is-9">
            {{ linked.description }}
            <br />
            <span v-if="linked.price"><strong>{{ linked.price | currency }}</strong></span>
          </div>
        </div>
      </div>
      <div class="content-controls">
        <div class="level is-mobile">
          <div class="level-right">
            <div class="level-item">
              <a class="button is-small" title="change content" @click="edit()">Edit</a>
            </div>
            <div class="level-item">
              <a class="button is-small" title="move to top" @click="moveToTop()"><i
                class="fa fa-angle-double-up"></i></a>
            </div>
            <div class="level-item">
              <a class="button is-small" title="move up" @click="moveUp()"><i class="fa fa-arrow-up"></i></a>
            </div>
            <div class="level-item">
              <a class="button is-small" title="move down" @click="moveDown()"><i
                class="fa fa-arrow-down"></i></a>
            </div>
            <div class="level-item">
              <a class="button is-small" title="move to bottom" @click="moveToBottom()"><i
                class="fa fa-angle-double-down"></i></a>
            </div>
            <div class="level-item">
              <a class="delete" title="remove content from page" @click="remove()"></a>
            </div>
          </div>
        </div>
      </div>
      <div class="content-display ql-content" v-if="content.content" v-html="content.content"></div>
    </div>

    <div class="content-select" v-if="selecting">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="control">
                            <span class="select">
                                <select name="contentType" v-model="selectedType">
                                    <option value="product">Product</option>
                                    <option value="bundle">Bundle</option>
                                    <option value="text">Text</option>
                                </select>
                            </span>
            </p>
          </div>
          <div class="level-item">
            <p class="control" v-if="selectedType === 'product'">
                            <span class="select">
                                <select name="selectedItem" v-model="selectedItem">
                                    <option>Select a product...</option>
                                    <option v-for="product in products" :value="product.id">
                                        {{ product.sku }} - {{ product.short_name }}
                                    </option>
                                </select>
                            </span>
            </p>
            <p class="control" v-if="selectedType === 'bundle'">
                            <span class="select">
                                <select name="selectedItem" v-model="selectedItem">
                                    <option>Select a bundle...</option>
                                    <option v-for="bundle in bundles" :value="bundle.id">
                                        {{ bundle.name }}</option>
                                </select>
                            </span>
            </p>
          </div>
          <div class="level-item">
            <div>
              <button type="button" class="button is-primary" @click="saveContent()">Save</button>
              <button type="button" class="button" @click="cancel()">Cancel</button>
            </div>
          </div>
        </div>
      </div>

      <p class="control ql-content" v-if="selectedType === 'text'">
        <quill-editor ref="myTextEditor" v-model="text"></quill-editor>
      </p>
    </div>

    <div v-if="content === false && !selecting" class="add-content">
      <a @click="addContent()">
                <span class="icon">
                    <i class="fa fa-plus"></i>
                </span>
        Add content to page
      </a>
    </div>
  </div>
</template>

<style lang="scss" rel="stylesheet/scss">
  .page-content-form {
    margin-bottom: 1rem;
    border: 1px solid #DDD;
    border-radius: 0.5rem;
    padding: 1rem;
  }

  .page-content {
    font-size: 0;
  }

  .content-type {
    display: inline-block;
    vertical-align: top;
    width: 10%;
    min-width: 60px;
    font-size: 1rem;
  }

  .content-item {
    display: inline-block;
    vertical-align: top;
    width: 66%;
    min-width: 400px;
    font-size: 1rem;
  }

  .content-display {
    margin-top: 1rem;
    padding: 0.5rem 1rem 2rem;
    border-top: 1px solid #E1E1E1;
    font-size: 1rem;
  }

  .ql-content {
    .ql-editor {
      p {
        margin: 1rem 0;
      }
    }

    p {
      margin: 1em 0;
    }

    ol, ul {
      padding-left: 2em
    }

    ul {
      list-style: disc;
    }

    .ql-indent-1 {
      text-indent: 2em
    }

    .ql-align-center {
      text-align: center
    }

    .ql-align-left {
      text-align: left
    }

    .ql-align-right {
      text-align: right
    }

    .ql-align-justify {
      text-align: justify
    }

    .ql-direction-rtl {
      direction: rtl
    }

    .ql-size-huge {
      font-size: 2em
    }

    .ql-size-large {
      font-size: 1.5em
    }

    .ql-size-small {
      font-size: 0.75em
    }

    .ql-font-serif {
      font-family: "Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif
    }

    .ql-font-monospace {
      font-family: "Fira Mono"
    }

    h1 {
      font-size: 2em;
    }

    h2 {
      font-size: 1.75em;
    }

    h3 {
      font-size: 1.5em;
    }

    h4 {
      font-size: 1.25em;
    }

    h5 {
      font-size: 1em;
    }

    h6 {
      font-size: 0.75em;
    }
  }

  .content-controls {
    display: inline-block;
    vertical-align: top;
    width: 24%;
    min-width: 100px;
    text-align: right;
    font-size: 1rem;
  }

  .quill-container {
    max-width: 600px;
  }
</style>

<script>
import {mapGetters} from "vuex"
import Form         from "../helpers/Form"
import sortAlphaNum from "../utils/sortAlphaNum"
import * as types   from "../store/mutation-types";

export default {
  props: {
    content: { type: [Boolean, Object, String], default: false },
    pageId: { type: [Number] }
  },
  data() {
    return {
      selecting: false,
      selectedType: 'product',
      selectedItem: null,
      text: null,
    }
  },
  computed: Object.assign({}, mapGetters(['products', 'bundles', 'pageContents', 'imageables', 'images']), {
    linked() {
      let type = this.content.page_content_type;
      if (type !== 'Bundle' && type !== 'Product') return {}
      let linked = this[type.toLowerCase() + 's'].find(link => {
        return link.id === this.content.page_content_id
      })

      if (type === 'Product') {
        let imageables = this.imageables.filter(imageable => {
          return imageable.imageable_type === type && imageable.imageable_id === this.content.page_content_id
        })
        let image_ids  = []
        for (let imageable in imageables) {
          image_ids.push(imageables[imageable].image_id)
        }

        linked.images = JSON.parse(JSON.stringify(this.images.filter(image => image_ids.indexOf(image.id) !== -1)))
      }
      else if (type === 'Bundle') {
        linked.images = JSON.parse(JSON.stringify(this.images.filter(image => image.id === linked.image_id)))
      }

      return linked
    }
  }),
  methods: {
    addContent() {
      this.selecting = true
    },
    edit() {
      this.selecting    = true;
      this.selectedType = this.content.page_content_type.toLowerCase();
      if (this.content.page_content_type === 'Text') {
        this.text = this.content.content;
      }
      else {
        this.selectedItem = this.content.page_content_id;
      }
    },
    cancel() {
      this.selecting    = false;
      this.selectedItem = null;
      this.selectedType = 'product';
    },
    saveContent() {
      if (this.content) {
        this.$store.dispatch(types.UPDATE_PAGE_CONTENT, {
          id: this.content.id,
          page_id: this.content.page_id,
          page_content_id: this.selectedItem,
          page_content_type: this.selectedType === "text" ? "Text" : this.selectedType === 'bundle'
            ? 'Bundle'
            : 'Product',
          content: this.text,
        }).then(data => {
          this.selecting    = false
          this.selectedType = 'product'
          this.selectedItem = null
          this.text         = null
        })
      }
      else {
        this.$store.dispatch(types.CREATE_PAGE_CONTENT, {
          page_id: this.pageId,
          page_content_id: this.selectedItem,
          page_content_type: this.selectedType === "text" ? "Text" : this.selectedType === 'bundle'
            ? 'Bundle'
            : 'Product',
          content: this.text,
        }).then(data => {
          this.selecting    = false
          this.selectedType = 'product'
          this.selectedItem = null
          this.text         = null
        })
      }
    },
    moveToTop() {
      if (this.content.sort < 1) return false
      this.$store.dispatch(types.SORT_PAGE_CONTENT, {
        'id': this.content.id,
        'position': 0,
        'page_id': this.content.page_id,
      })
    },
    moveToBottom() {
      let contents = this.pageContents.filter(content => content.page_id === this.content.page_id)
      contents     = contents.sort((a, b) => a.sort - b.sort)
      if (this.content.sort === contents[contents.length - 1].sort) return false
      this.$store.dispatch(types.SORT_PAGE_CONTENT, {
        'id': this.content.id,
        'position': contents.length - 1,
        'page_id': this.content.page_id,
      })
    },
    moveUp() {
      if (this.content.sort < 1) return false
      this.$store.dispatch(types.SORT_PAGE_CONTENT, {
        'id': this.content.id,
        'position': this.content.sort - 1,
        'page_id': this.content.page_id,
      })
    },
    moveDown() {
      let contents = this.pageContents.filter(content => content.page_id === this.content.page_id)
      contents     = contents.sort((a, b) => a.sort - b.sort)
      if (this.content.sort === contents[contents.length - 1].sort) return false
      this.$store.dispatch(types.SORT_PAGE_CONTENT, {
        'id': this.content.id,
        'position': this.content.sort + 1,
        'page_id': this.content.page_id,
      })
    },
    remove() {
      let confirm = window.confirm('Are you sure?')
      if (confirm) {
        this.$store.dispatch(types.DELETE_PAGE_CONTENT, this.content);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// PageContent.vue?5fb7e4a8